const heroData = [
  {
    id: 0,
    title_1: "hello, 👋 I am ",
    title_2: "Aditya Mall",
    title_3: "<frontend developer/>",
    info_1:
      "who enjoys building things that live on the internet. Aiming for React, Javascript and other web development opportunities.",
    info_2:
      "Looking for entry level/junior roles where my skills can be used to solve complex UI challenges and provide value to the growth of an organization. ",
  },
]; 

export {heroData};